import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Shield } from 'lucide-react';
export function Privacy() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-556">
      <Header data-id="element-557" />
      <main className="flex-grow" data-id="element-558">
        <section className="py-20 bg-gradient-to-br from-[#0D7377] to-[#14919B] text-white" data-id="element-559">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-560">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white bg-opacity-20 rounded-full mb-6" data-id="element-561">
              <Shield size={32} data-id="element-562" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-563">
              Privacy & Cookie Policy
            </h1>
            <p className="text-xl text-gray-100" data-id="element-564">
              How we protect and use your personal information
            </p>
          </div>
        </section>
        <section className="py-16 bg-white" data-id="element-565">
          <div className="max-w-4xl mx-auto px-4" data-id="element-566">
            <div className="prose prose-lg max-w-none" data-id="element-567">
              <div className="bg-gray-50 p-6 rounded-xl mb-8" data-id="element-568">
                <p className="text-sm text-gray-600" data-id="element-569">
                  <strong data-id="element-570">Data Controller:</strong> Caringhand
                  <br data-id="element-571" />
                  <strong data-id="element-572">Address:</strong> 157 Ashley Rd, Hale, Altrincham WA15
                  9SD
                  <br data-id="element-573" />
                  <strong data-id="element-574">Contact:</strong> info@caringhand.it.com | 0800 055
                  4969
                </p>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-575">
                Who We Are
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6" data-id="element-576">
                Caringhand is a UK-based appliance repair and maintenance
                service provider. We are committed to protecting your privacy
                and handling your personal data responsibly in accordance with
                the UK General Data Protection Regulation (UK GDPR) and the Data
                Protection Act 2018.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-577">
                What Data We Collect
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-578">
                We collect and process the following types of personal
                information:
              </p>
              <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2" data-id="element-579">
                <li data-id="element-580">
                  <strong data-id="element-581">Contact Information:</strong> Name, email address,
                  phone number, and postal address
                </li>
                <li data-id="element-582">
                  <strong data-id="element-583">Booking Data:</strong> Appliance type, fault
                  description, preferred appointment dates
                </li>
                <li data-id="element-584">
                  <strong data-id="element-585">Payment Information:</strong> Payment confirmations
                  processed securely through Stripe (we do not store card
                  details)
                </li>
                <li data-id="element-586">
                  <strong data-id="element-587">Technical Data:</strong> IP address, browser type,
                  device information when you visit our website
                </li>
                <li data-id="element-588">
                  <strong data-id="element-589">Communication Records:</strong> Email and phone
                  correspondence related to your booking
                </li>
              </ul>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-590">
                Why We Collect Your Data
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-591">
                We use your personal information for the following purposes:
              </p>
              <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2" data-id="element-592">
                <li data-id="element-593">To manage and fulfil your repair bookings</li>
                <li data-id="element-594">To communicate with you about your service</li>
                <li data-id="element-595">To process payments securely through Stripe</li>
                <li data-id="element-596">To comply with legal and regulatory requirements</li>
                <li data-id="element-597">To improve our services and customer experience</li>
                <li data-id="element-598">To send service updates and important notifications</li>
              </ul>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-599">
                Legal Basis for Processing
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-600">
                We process your personal data under the following legal bases:
              </p>
              <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2" data-id="element-601">
                <li data-id="element-602">
                  <strong data-id="element-603">Contract Performance:</strong> To fulfil our service
                  agreement with you
                </li>
                <li data-id="element-604">
                  <strong data-id="element-605">Legal Obligation:</strong> To comply with accounting,
                  tax, and other legal requirements
                </li>
                <li data-id="element-606">
                  <strong data-id="element-607">Legitimate Interest:</strong> To improve our services
                  and communicate effectively
                </li>
                <li data-id="element-608">
                  <strong data-id="element-609">Consent:</strong> For marketing communications (you
                  can opt out at any time)
                </li>
              </ul>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-610">
                Who We Share Your Data With
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-611">
                We only share your personal information with trusted partners
                necessary to deliver our services:
              </p>
              <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2" data-id="element-612">
                <li data-id="element-613">
                  <strong data-id="element-614">Payment Processors:</strong> Stripe processes payments
                  securely on our behalf
                </li>
                <li data-id="element-615">
                  <strong data-id="element-616">Website Hosting:</strong> Our website hosting provider
                  stores data securely in the UK/EU
                </li>
                <li data-id="element-617">
                  <strong data-id="element-618">Email Services:</strong> We use email service
                  providers to communicate with you
                </li>
                <li data-id="element-619">
                  <strong data-id="element-620">Engineers:</strong> We share necessary booking details
                  with our qualified engineers
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed mb-6" data-id="element-621">
                We never sell your personal data to third parties for marketing
                purposes.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-622">
                How Long We Keep Your Data
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6" data-id="element-623">
                We retain your personal information only for as long as
                necessary to fulfil the purposes outlined in this policy.
                Typically, we keep booking and payment records for 6 years to
                comply with accounting and tax regulations. Marketing data is
                retained until you opt out or request deletion.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-624">
                Cookies & Website Tracking
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-625">
                Our website uses cookies to improve your browsing experience.
                Cookies are small text files stored on your device. We use:
              </p>
              <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2" data-id="element-626">
                <li data-id="element-627">
                  <strong data-id="element-628">Essential Cookies:</strong> Required for the website
                  to function properly
                </li>
                <li data-id="element-629">
                  <strong data-id="element-630">Analytics Cookies:</strong> Help us understand how
                  visitors use our site (Google Analytics)
                </li>
                <li data-id="element-631">
                  <strong data-id="element-632">Preference Cookies:</strong> Remember your settings
                  and choices
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed mb-6" data-id="element-633">
                You can control cookies through your browser settings. Disabling
                certain cookies may affect website functionality.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-634">
                Your Data Protection Rights
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-635">
                Under UK GDPR, you have the following rights:
              </p>
              <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2" data-id="element-636">
                <li data-id="element-637">
                  <strong data-id="element-638">Right to Access:</strong> Request a copy of your
                  personal data
                </li>
                <li data-id="element-639">
                  <strong data-id="element-640">Right to Rectification:</strong> Correct inaccurate or
                  incomplete data
                </li>
                <li data-id="element-641">
                  <strong data-id="element-642">Right to Erasure:</strong> Request deletion of your
                  data (subject to legal requirements)
                </li>
                <li data-id="element-643">
                  <strong data-id="element-644">Right to Restriction:</strong> Limit how we use your
                  data
                </li>
                <li data-id="element-645">
                  <strong data-id="element-646">Right to Object:</strong> Oppose processing based on
                  legitimate interests
                </li>
                <li data-id="element-647">
                  <strong data-id="element-648">Right to Portability:</strong> Receive your data in a
                  structured, machine-readable format
                </li>
                <li data-id="element-649">
                  <strong data-id="element-650">Right to Withdraw Consent:</strong> Opt out of
                  marketing at any time
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed mb-6" data-id="element-651">
                To exercise any of these rights, please contact us at
                info@caringhand.it.com or 0800 055 4969.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-652">
                Data Security
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6" data-id="element-653">
                We implement appropriate technical and organisational measures
                to protect your personal data against unauthorised access, loss,
                or misuse. Payment information is processed securely through
                Stripe, and we use encryption for sensitive communications.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-654">
                Changes to This Policy
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6" data-id="element-655">
                We may update this privacy policy from time to time to reflect
                changes in our practices or legal requirements. Any changes will
                be posted on this page with an updated revision date.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-656">
                Contact Us
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-657">
                If you have any questions about this privacy policy or how we
                handle your data, please contact us:
              </p>
              <div className="bg-[#0D7377] bg-opacity-10 p-6 rounded-xl" data-id="element-658">
                <p className="text-gray-700 mb-2" data-id="element-659">
                  <strong data-id="element-660">Email:</strong> info@caringhand.it.com
                </p>
                <p className="text-gray-700 mb-2" data-id="element-661">
                  <strong data-id="element-662">Phone:</strong> 0800 055 4969
                </p>
                <p className="text-gray-700" data-id="element-663">
                  <strong data-id="element-664">Address:</strong> 157 Ashley Rd, Hale, Altrincham WA15
                  9SD
                </p>
              </div>
              <p className="text-gray-700 leading-relaxed mt-6" data-id="element-665">
                You also have the right to lodge a complaint with the
                Information Commissioner's Office (ICO), the UK supervisory
                authority for data protection issues. Visit{' '}
                <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer" className="text-[#0D7377] hover:underline" data-id="element-666">
                  ico.org.uk
                </a>{' '}
                for more information.
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-667" />
    </div>;
}